import { render, staticRenderFns } from "./contentAdd.vue?vue&type=template&id=73c0ca62&scoped=true"
import script from "./contentAdd.vue?vue&type=script&lang=js"
export * from "./contentAdd.vue?vue&type=script&lang=js"
import style0 from "./contentAdd.vue?vue&type=style&index=0&id=73c0ca62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c0ca62",
  null
  
)

export default component.exports